<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781429938204_toc01#toctitle7" id="title7"><span><strong class="b">PART I</strong></span></a></div>
<div class="subtitle-part"><strong class="b">THE TIME OF THE SHOAH</strong></div>
<div class="p-c-br"><span>Arab Reactions to Nazism <br/>and Anti-Semitism, <br/>1933–47</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429938204_p01.vue?69cf7eb4